import { display, addEventListener, buildEndpointHost } from '@datadog/browser-core';
const REMOTE_CONFIGURATION_VERSION = 'v1';
const STATIC_OPTIONS = [
    'applicationId',
    'service',
    'env',
    'version',
    'sessionSampleRate',
    'sessionReplaySampleRate',
    'defaultPrivacyLevel',
    'enablePrivacyForActionName',
];
export function fetchAndApplyRemoteConfiguration(initConfiguration, callback) {
    fetchRemoteConfiguration(initConfiguration, (remoteInitConfiguration) => {
        callback(applyRemoteConfiguration(initConfiguration, remoteInitConfiguration));
    });
}
export function applyRemoteConfiguration(initConfiguration, rumRemoteConfiguration) {
    // intents:
    // - explicitly set each supported field to limit risk in case an attacker can create configurations
    // - check the existence in the remote config to avoid clearing a provided init field
    const appliedConfiguration = { ...initConfiguration };
    STATIC_OPTIONS.forEach((option) => {
        if (option in rumRemoteConfiguration) {
            appliedConfiguration[option] = rumRemoteConfiguration[option];
        }
    });
    return appliedConfiguration;
}
export function fetchRemoteConfiguration(configuration, callback) {
    const xhr = new XMLHttpRequest();
    addEventListener(configuration, xhr, 'load', function () {
        if (xhr.status === 200) {
            const remoteConfiguration = JSON.parse(xhr.responseText);
            if (remoteConfiguration.rum) {
                callback(remoteConfiguration.rum);
            }
            else {
                display.error('No remote configuration for RUM.');
            }
        }
        else {
            displayRemoteConfigurationFetchingError();
        }
    });
    addEventListener(configuration, xhr, 'error', function () {
        displayRemoteConfigurationFetchingError();
    });
    xhr.open('GET', buildEndpoint(configuration));
    xhr.send();
}
export function buildEndpoint(configuration) {
    return `https://sdk-configuration.${buildEndpointHost('rum', configuration)}/${REMOTE_CONFIGURATION_VERSION}/${encodeURIComponent(configuration.remoteConfigurationId)}.json`;
}
function displayRemoteConfigurationFetchingError() {
    display.error('Error fetching the remote configuration.');
}
//# sourceMappingURL=remoteConfiguration.js.map